

export const TabsData = [
    { nombre: "Datos personales", carpeta: "PerfilDatosPersonales", componente: "DatosPersonales", params: { key: 0 } },
    { nombre: "Obra social", carpeta: "PerfilDatosPersonales", componente: "ObraSocial", params: { key: 1 } }
  ];
  